<template>
  <div>
    components page
  </div>
</template>

<script>
export default {
  name: 'componentspage1'
}
</script>

<style lang="stylus" scoped>

</style>
